import { useTranslation } from 'react-i18next';
import { Error, CheckCircle, ExpandMore } from '@mui/icons-material';
import { Box, Typography } from '../../1-primative';
import { Accordion, AccordionSummary, AccordionDetails } from '../../2-component';
import { useThemeTokens } from '../../../providers/themeTokenProvider';
import { translateBackend } from '../../../assets/i18n/config';
import { Transfer } from '../../../interfaces';

interface AlertReportRule {
  type: string;
  translatedDescription: {
    en: string;
    fr: string;
  };
}

export const SuspiciousActivityAccordion = ({ transfer }: { transfer: Transfer }) => {
  const { t } = useTranslation(['components', 'shared']);
  const { sys } = useThemeTokens();

  return (
    <Accordion
      sx={{
        boxShadow: 'none !important',
        backgroundColor: transfer?.isSuspicious ? sys.color.negativeVariant : sys.color.positiveVariant,
        border: `1px solid ${transfer?.isSuspicious ? sys.color.negativeVariantPressed : sys.color.positiveVariantPressed} !important`,
        borderRadius: `${sys.borderRadius.md} !important`,
        overflow: 'hidden',
        '& .MuiSvgIcon-root': { width: '20px' },
        '& .MuiAccordionSummary-root': {
          borderTop: 'none !important',
        },
      }}
      multiple
    >
      <AccordionSummary expandIcon={transfer?.isSuspicious && <ExpandMore sx={{ color: sys.color.onSurface }} />}>
        <Box display='flex' alignItems='center' gap='8px'>
          {transfer?.isSuspicious ? <Error color='error' /> : <CheckCircle color='success' />}
          <Typography variant='bodyLarge' weight='bold'>
            {transfer?.isSuspicious ? t('components:suspiciousActivityDetected') : t('components:noSuspiciousActivity')}
          </Typography>
        </Box>
      </AccordionSummary>
      {transfer?.alertReport && (
        <AccordionDetails sx={{ py: 0, pb: 0.5 }}>
          {transfer?.alertReport?.rules.map((rule: AlertReportRule, index: number) => (
            <Box display='flex' justifyContent='space-between' alignItems='center' py={1}
              borderBottom={index !== (transfer?.alertReport?.rules.length ?? 0) - 1 ? `1px solid ${sys.color.negativeVariantHover}` : 'none'}>
              <Typography variant='bodySmall' weight='bold'>{t(`components:ruleTypes.${rule.type}`)}</Typography>
              <Typography variant='bodySmall' textAlign='right'>{translateBackend(rule.translatedDescription)}</Typography>
            </Box>
          ))}
        </AccordionDetails>
      )}
    </Accordion>
  );
};
